<div class="tab" [class.active]="active" (click)="onSelect()">
  <div class="icon-box2" [innerHTML]="svgIcon"></div>
  <p>{{ title }}</p>
</div>
